import React from 'react';

import { FilterChip } from '@pkg/components/Filters/FilterChips/FilterChip';

import { useNFTsFiltersStore } from '@app/store/zustand';

import { ClearAction, ClearActionLabel, ResultsText, Wrapper } from './FilterChips.style';

export function FilterChips({ filteredResultCount }: { filteredResultCount?: number }) {
    const { currentFilters, resetFilters } = useNFTsFiltersStore();
    const selectedTotal = currentFilters.total;

    const resultsMarkup =
        selectedTotal && filteredResultCount ? <ResultsText>{`${filteredResultCount} Results`}</ResultsText> : null;
    const clearActionMarkup = selectedTotal ? (
        <ClearAction onAction={resetFilters}>
            <ClearActionLabel>Clear all</ClearActionLabel>
        </ClearAction>
    ) : null;

    const parsedFilters = currentFilters.parse as Record<string, string[]>;
    const selectedFilters = Object.keys(parsedFilters).filter((key) => parsedFilters[key]?.length);
    const chipMarkup = selectedFilters?.map((filter) => <FilterChip key={filter} text={filter} />);

    // TODO: This component should animate in/out.
    return (
        <Wrapper>
            {resultsMarkup}
            {chipMarkup}
            {clearActionMarkup}
        </Wrapper>
    );
}
